module.exports = __webpack_public_path__ + "img/prw_pixelrealmtk.3870b05.png";